export default "__VITE_ASSET__C$0gR3jD__"